import React, { useState, useEffect } from 'react';
import Button from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal';
import Form from 'react-bootstrap/Form';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
// import axios from 'axios';
import { ServerPath } from '../../../Constant';
// import { uploadImage } from '../../../Config/azure-storage-blob.ts';
import {uploadImage} from '../../../Services/r2-storage-blob.js';


import { _axios } from '../../../utils/axios';

const EditTagDetails = ({ tagDetails, onUpdate }) => {
    const [show, setShow] = useState(false);
    const [waypoints, setWaypoints] = useState([]); // New state for waypoints
    const [error, setError] = useState('');
    const [tagError, setTagError] = useState('');
  const [sessionIds, setSessionIds] = useState([]);

    const [formData, setFormData] = useState({
        id: '',
        location_id: '',
        wpt_id: '',
        wpt_name: '',
        river_sect: '',
        lat: '',
        lon: '',
        plot_start_name: '',
        town: '',
        dist: '',
        state: '',
        pincode: '',
        prev_walk_wpt_dist: '',
        next_walk_wpt_dist: '',
        next_walk_wpt_time: '',
        trail_type: '',
        importance: '',
        landmark: '',
        thumbnail: '',
        dist_police_stn: '',
        d_reg_acmd: '',
        d_reg_eateries: '',
        d_reg_medical: '',
        d_reg_clinic: '',
        d_reg_hosp: '',
        dist_bus_stnd: '',
        dist_rail_stn: '',
        wpt_desc: '',
        vivekji_desc: '',
        status: '1',
        image: null,
        tag: '',
        tpt_id: '',
        activity: '',
        journey_time_in_mins: '',
        session_id_daywise: '',
        understand_desc: '',
        avg_time_spent_min: '',
        place: '',
        wpt_category_name: '',
        wpt_type_name: '',
        popular_for: '',
        short_desc: '',
        wpt_type_id: '',
        wpt_type_ids: '',
        wpt_category_id: '',
        id: '' // for identifying the record to update
    });

  useEffect(() => {
        if (tagDetails) {
            // Validate if the incoming tag value exists in uniqueOptions
            const validTag = tagDetails.tag && uniqueOptions.includes(tagDetails.tag) 
                ? tagDetails.tag 
                : '';
            
            if (tagDetails.tag && !uniqueOptions.includes(tagDetails.tag)) {
                setTagError(`Warning: The saved tag "${tagDetails.tag}" is not in the current list of valid options.`);
            }

            setFormData(prevState => ({
                ...prevState,
                ...tagDetails,
                tag: validTag // Set the validated tag value
            }));
        }
    }, [tagDetails]);

    useEffect(() => {
        const fetchWaypoints = async () => {
            try {
                const response = await _axios.get(`${ServerPath}/tagdetails/waypoints`);
                const waypointsData = response.data.data || [];
                setWaypoints(waypointsData);
            } catch (error) {
                console.error('Error fetching waypoints:', error);
                setWaypoints([]);
            }
        };

        fetchWaypoints();
    }, []);

    useEffect(() => {
        const fetchSessionIds = async () => {
          try {
            const response = await _axios.get(`${ServerPath}/waypointDetails/getDistinctSessionIds`);
            // Check if response.data exists and has the expected structure
            if (response.data && Array.isArray(response.data)) {
              setSessionIds(response.data);
            } else if (response.data && response.data.data && Array.isArray(response.data.data)) {
              // If the data is nested under a 'data' property
              setSessionIds(response.data.data);
            } else {
              console.error("Unexpected API response structure:", response.data);
              setSessionIds([]); // Set to empty array as fallback
            }
          } catch (error) {
            console.error("Error fetching session IDs:", error);
            setSessionIds([]); // Set to empty array on error
          }
        };
    
        fetchSessionIds();
      }, []);

    useEffect(() => {
        if (tagDetails && waypoints.length > 0) {
            const selectedWaypoint = waypoints.find(wp => wp.wpt_id === tagDetails.wpt_id);
            if (selectedWaypoint) {
                setFormData(prevState => ({
                    ...prevState,
                    ...tagDetails,
                    // wpt_name: selectedWaypoint.wpt_name
                }));
            } else {
                setFormData(prevState => ({
                    ...prevState,
                    ...tagDetails
                }));
            }
        }
    }, [tagDetails, waypoints]);

    const handleWaypointSelect = (e) => {
        const selectedWptId = e.target.value;
        const selectedWaypoint = waypoints.find(wp => wp.wpt_id === selectedWptId);

        if (selectedWaypoint) {
            setFormData(prevData => ({
                ...prevData,
                wpt_id: selectedWaypoint.wpt_id,
            }));
        }
    };

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        
        if (name === 'tag') {
            setTagError(''); // Clear any previous tag errors
            
            // Validate tag selection
            if (!value && tagDetails?.tag) {
                setTagError('Please select a tag value');
            }
        }

        setFormData(prevData => ({
            ...prevData,
            [name]: value
        }));
    };

    const handleFileChange = async (e) => {
        const file = e.target.files[0];
        if (file) {
            try {
                const filename = `tag_detail_${Date.now()}`;
                const container = 'tag-details';
                const subcontainer = 'images';

                const url = await uploadImage(file, filename, container, subcontainer);
                console.log('Image uploaded successfully. URL:', url);

                setFormData(prevState => ({
                    ...prevState,
                    image: url,
                    images: url
                }));
            } catch (error) {
                console.error('Error uploading image:', error);
            }
        }
    };

    const handleClose = () => setShow(false);
    const handleShow = () => setShow(true);

    const uniqueOptions = ["Temple", "RestHouse", "SightSeeing", "Ashram", "Meditation centre"];

    const handleSubmit = async (event) => {

        event.preventDefault();
        const requiredFields = [
            'wpt_id',
            'wpt_name',
            'lat',
            'lon',
            'tag',
            'river_sect',
            'town',
            'dist',
            'state',
            'pincode',
            'trail_type',
            'importance'
        ];

        // Check required fields
        const missingFields = requiredFields.filter(key => {
            const value = formData[key];
            return value === '' || value === null || value === undefined || 
                   (typeof value === 'number' && isNaN(value));
        });
        
        if (missingFields.length > 0) {
            console.log('Missing fields:', missingFields);
            setError(`Please fill in the following required fields: ${missingFields.join(', ')}`);
            return;
        }

        // Clear any previous error
        setError('');

        event.preventDefault();

        const dataToSend = {
            id: formData.id,
            location_id: formData.location_id || "",
            wpt_id: formData.wpt_id || "",
            wpt_name: formData.wpt_name || "",
            river_sect: formData.river_sect || "",
            lat: parseFloat(formData.lat) || 0,
            lon: parseFloat(formData.lon) || 0,
            plot_start_name: formData.plot_start_name || "",
            town: formData.town || "",
            dist: formData.dist || "",
            state: formData.state || "",
            pincode: formData.pincode || "",
            prev_walk_wpt_dist: parseInt(formData.prev_walk_wpt_dist, 10) || 0,
            next_walk_wpt_dist: parseInt(formData.next_walk_wpt_dist, 10) || 0,
            next_walk_wpt_time: formData.next_walk_wpt_time || "",
            trail_type: formData.trail_type || "",
            importance: formData.importance || "",
            landmark: formData.landmark || "",
            thumbnail: formData.thumbnail || "",
            dist_police_stn: parseInt(formData.dist_police_stn, 10) || 0,
            d_reg_acmd: formData.d_reg_acmd || "",
            d_reg_eateries: formData.d_reg_eateries || "",
            d_reg_medical: formData.d_reg_medical || "",
            d_reg_clinic: formData.d_reg_clinic || "",
            d_reg_hosp: formData.d_reg_hosp || "",
            dist_bus_stnd: parseInt(formData.dist_bus_stnd, 10) || 0,
            dist_rail_stn: formData.dist_rail_stn ? parseInt(formData.dist_rail_stn, 10) : null,
            wpt_desc: formData.wpt_desc || "",
            vivekji_desc: formData.vivekji_desc || "",
            images: formData.image || formData.images || tagDetails.images || "",
            status: parseInt(formData.status, 10) || 1,
            tag: formData.tag || "",
              // Added missing fields
              tpt_id: formData.tpt_id || "",
              activity: formData.activity || "",
              journey_time_in_mins: parseInt(formData.journey_time_in_mins, 10) || 0,
              session_id_daywise: formData.session_id_daywise || "",
              understand_desc: formData.understand_desc || "",
              avg_time_spent_min: parseInt(formData.avg_time_spent_min, 10) || 0,
              place: formData.place || "",
              wpt_category_name: formData.wpt_category_name || "",
              wpt_type_name: formData.wpt_type_name || "",
              popular_for: formData.popular_for || "",
              short_desc: formData.short_desc || "",
              wpt_type_id: formData.wpt_type_id || "",
              wpt_type_ids: formData.wpt_type_ids || "",
              wpt_category_id: formData.wpt_category_id || "",
              id: formData.id || "" // for identifying the record to update
        };

        if (formData.image) {
            // If a new image has been selected, use it
            dataToSend.images = formData.image;
        } else if (tagDetails && tagDetails.images) {
            // If no new image, use the previous image URL
            dataToSend.images = tagDetails.images;
        } else {
            // If there's no new image and no previous image, set it to an empty string
            dataToSend.images = "";
        }

        console.log('Data being sent:', dataToSend);

        try {
            const response = await _axios.post(`${ServerPath}/waypointDetails/update-gpx-route`, dataToSend, {
                headers: {
                    'Content-Type': 'application/json'
                }
            });

            console.log('API Response:', response.data);
            handleClose();
            window.location.reload();
            if (onUpdate) onUpdate();
        } catch (error) {
            console.error('Error updating form:', error);
            if (error.response) {
                console.error('Error response:', error.response.data);
                console.error('Status:', error.response.status);
                console.error('Headers:', error.response.headers);
            } else if (error.request) {
                console.error('No response received:', error.request);
            } else {
                console.error('Error setting up request:', error.message);
            }
        }
    };

    const ImagePreviewSection = () => {
        const currentImage = formData.image || formData.thumbnail || tagDetails?.images;
        
        return (
            <Col md={6}>
                <Form.Group>
                    <Form.Label>Image</Form.Label>
                    <div className="mb-3">
                        {currentImage && (
                            <div className="mb-3">
                                <img 
                                    src={currentImage} 
                                    alt="Current thumbnail" 
                                    className="img-thumbnail" 
                                    style={{ maxHeight: '200px' }}
                                />
                            </div>
                        )}
                        <Form.Control
                            type="file"
                            name="image"
                            onChange={handleFileChange}
                            accept="image/*"
                        />
                        <small className="text-muted">
                            Select a new image to update, or leave empty to keep the existing image
                        </small>
                    </div>
                </Form.Group>
            </Col>
        );
    };
    
    return (
        <>
            <Button onClick={handleShow} className="btn-square btn btn-primary mx-2"><i className='icon-pencil-alt'></i></Button>
            <Modal
                show={show}
                onHide={handleClose}
                backdrop="static"
                keyboard={false}
                size="xl"
                //  dialogClassName="modal-90w"
                aria-labelledby="contained-modal-title-vcenter"
                centered
            >
                <Modal.Header closeButton>
                    <Modal.Title>Edit Waypoint Details</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    {error && <div className="alert alert-danger">{error}</div>}

                    <Form onSubmit={handleSubmit}>
                        <Row>
                            <Col md={3}>

                                <Form.Group>
                                    <Form.Label>Waypoint ID</Form.Label>
                                    <Form.Select
                                        name="wpt_id"
                                        value={formData.wpt_id}
                                        onChange={handleWaypointSelect}
                                    >
                                        <option value="">Select a waypoint</option>
                                        {waypoints.map((wp) => (
                                            <option key={wp.wpt_id} value={wp.wpt_id}>
                                                {wp.wpt_name} {wp.wpt_id}
                                            </option>
                                        ))}
                                    </Form.Select>
                                </Form.Group>
                            </Col>
                            <Col md={3}>
                                <Form.Group>
                                    <Form.Label>Place Name</Form.Label>
                                    <Form.Control
                                        type="text"
                                        name="wpt_name"
                                        value={formData.wpt_name}
                                        onChange={handleInputChange}
                                        required
                                        placeholder="wpt_name"
                                    />
                                </Form.Group>
                            </Col>
                            <Col md={3}>
                                <Form.Group>
                                    <Form.Label>River section</Form.Label>
                                    <Form.Control
                                        as="select"
                                        name="river_sect"
                                        value={formData.river_sect}
                                        onChange={handleInputChange}
                                    >
                                        <option value="">Select</option>
                                        <option value="North">North</option>
                                        <option value="South">South</option>
                                    </Form.Control>
                                </Form.Group>
                            </Col>

              <Col md={3}>
                <Form.Group>
                  <Form.Label>Activity</Form.Label>
                  <Form.Control
                    type="text"
                    name="activity"
                    value={formData.activity}
                    onChange={handleInputChange}
                    required
                  />
                </Form.Group>
              </Col>
              
            </Row>
            <Row className="mt-3">
              <Col md={3}>
                <Form.Group>
                  <Form.Label>Session ID Daywise</Form.Label>
                  <Form.Select
                    name="session_id_daywise"
                    value={formData.session_id_daywise || ''}
                    onChange={handleInputChange}
                  >
                    <option value="">Select Session ID</option>
                    {sessionIds.map((session) => (
                      <option
                        key={session.session_id_daywise}
                        value={session.session_id_daywise}
                      >
                        {session.session_id_daywise}
                      </option>
                    ))}
                  </Form.Select>
                </Form.Group>
              </Col>
                            <Col md={3}>
                                <Form.Group>
                                    <Form.Label>Latitude</Form.Label>
                                    <Form.Control
                                        type="text"
                                        name="lat"
                                        value={formData.lat}
                                        onChange={handleInputChange}
                                        required
                                        placeholder="Latitude"
                                    />
                                </Form.Group>
                            </Col>


                        </Row>
                        <Row>
                            <Col md={3}>
                                <Form.Group>
                                    <Form.Label>Longitude</Form.Label>

                                    <Form.Control
                                        type="text"
                                        name="lon"
                                        value={formData.lon}
                                        onChange={handleInputChange}
                                        required
                                        placeholder="Longitude"
                                    />
                                </Form.Group>
                            </Col>
                            <Col md={3}>
                                <Form.Group>
                                    <Form.Label>Plot &amp; Street Name</Form.Label>
                                    <Form.Control
                                        type="text"
                                        name="plot_start_name"
                                        value={formData.plot_start_name}
                                        onChange={handleInputChange}
                                    />
                                </Form.Group>
                            </Col>
                            <Col md={3}>
                                <Form.Group>
                                    <Form.Label>Village or Town or City</Form.Label>
                                    <Form.Control
                                        type="text"
                                        name="town"
                                        value={formData.town}
                                        onChange={handleInputChange}
                                    />
                                </Form.Group>
                            </Col>
                            <Col md={3}>
                                <Form.Group>
                                    <Form.Label>District</Form.Label>
                                    <Form.Control
                                        type="text"
                                        name="dist"
                                        value={formData.dist}
                                        onChange={handleInputChange}
                                    />
                                </Form.Group>
                            </Col>

                        </Row>

                        <Row>
                            <Col md={3}>
                                <Form.Group>
                                    <Form.Label>State</Form.Label>
                                    <Form.Control
                                        type="text"
                                        name="state"
                                        value={formData.state}
                                        onChange={handleInputChange}
                                    />
                                </Form.Group>
                            </Col>

                            <Col md={3}>
                                <Form.Group>
                                    <Form.Label>Pincode</Form.Label>
                                    <Form.Control
                                        type="text"
                                        name="pincode"
                                        value={formData.pincode}
                                        onChange={handleInputChange}
                                    />
                                </Form.Group>
                            </Col>
                            <Col md={3}>
                                <Form.Group>
                                    <Form.Label>Previous Waypoint Distance (m)</Form.Label>
                                    <Form.Control
                                        type="number"
                                        name="prev_walk_wpt_dist"
                                        value={formData.prev_walk_wpt_dist}
                                        onChange={handleInputChange}
                                        placeholder="Distance in meters"
                                    />
                                </Form.Group>
                            </Col>
                            <Col md={3}>
                                <Form.Group>
                                    <Form.Label>Next Waypoint Distance (m)</Form.Label>
                                    <Form.Control
                                        type="number"
                                        name="next_walk_wpt_dist"
                                        value={formData.next_walk_wpt_dist}
                                        onChange={handleInputChange}
                                        placeholder="Distance in meters"
                                    />
                                </Form.Group>
                            </Col>
                            <Col md={3}>
                                <Form.Group>
                                    <Form.Label>Next Waypoint Time (mins)</Form.Label>
                                    <Form.Control
                                        type="text"
                                        name="next_walk_wpt_time"
                                        value={formData.next_walk_wpt_time}
                                        onChange={handleInputChange}
                                        placeholder="Time in minutes"
                                    />
                                </Form.Group>
                            </Col>
                            <Col md={3}>
                                <Form.Group>
                                    <Form.Label>Trail Type</Form.Label>
                                    <Form.Select
                                        name="trail_type"
                                        value={formData.trail_type}
                                        onChange={handleInputChange}
                                    >
                                        <option value="">Select Trail Type</option>
                                        <option value="Unpaved">Unpaved</option>
                                        <option value="Partially Paved">Partially Paved</option>
                                        <option value="Paved">Paved</option>
                                    </Form.Select>
                                </Form.Group>
                            </Col>
                            <Col md={3}>
                                <Form.Group>
                                    <Form.Label>Importance</Form.Label>
                                    <Form.Select
                                        name="importance"
                                        value={formData.importance}
                                        onChange={handleInputChange}
                                    >
                                        <option value="">Select Importance</option>
                                        <option value="Low">Low</option>
                                        <option value="Medium">Medium</option>
                                        <option value="High">High</option>
                                        <option value="Very High">Very High</option>
                                    </Form.Select>
                                </Form.Group>
                            </Col>
                            <Col md={3}>
                                <Form.Group>
                                    <Form.Label>Landmark</Form.Label>
                                    <Form.Control
                                        type="text"
                                        name="landmark"
                                        value={formData.landmark}
                                        onChange={handleInputChange}
                                        placeholder="Landmark"
                                    />
                                </Form.Group>
                            </Col>

                            <Col md={3}>
                                <Form.Group>
                                    <Form.Label>Police Station Distance (m)</Form.Label>
                                    <Form.Control
                                        type="number"
                                        name="dist_police_stn"
                                        value={formData.dist_police_stn}
                                        onChange={handleInputChange}
                                        placeholder="Distance in meters"
                                    />
                                </Form.Group>
                            </Col>
                        </Row>
                        <Row>
                            <Col md={3}>
                                <Form.Group>
                                    <Form.Label>Bus Stand Distance (m)</Form.Label>
                                    <Form.Control
                                        type="number"
                                        name="dist_bus_stnd"
                                        value={formData.dist_bus_stnd}
                                        onChange={handleInputChange}
                                        placeholder="Distance in meters"
                                    />
                                </Form.Group>
                            </Col>
                            <Col md={3}>
                                <Form.Group>
                                    <Form.Label>Railway Station Distance (m)</Form.Label>
                                    <Form.Control
                                        type="number"
                                        name="dist_rail_stn"
                                        value={formData.dist_rail_stn}
                                        onChange={handleInputChange}
                                        placeholder="Distance in meters"
                                    />
                                </Form.Group>
                            </Col>
                            <Col md={3}>
                                <Form.Group>
                                    <Form.Label>Walking Distance to next waypoint(in mtrs)</Form.Label>
                                    <Form.Control
                                        type="number"
                                        name="next_walk_wpt_dist"
                                        value={formData.next_walk_wpt_dist}
                                        onChange={handleInputChange}
                                    />
                                </Form.Group>
                            </Col>
                            <Col md={3}>
                                <Form.Group>
                                    <Form.Label>Walking Distance to next waypoint(in mins)</Form.Label>
                                    <Form.Control
                                        type="text"
                                        name="next_walk_wpt_time"
                                        value={formData.next_walk_wpt_time}
                                        onChange={handleInputChange}
                                    />
                                </Form.Group>
                            </Col>
                        </Row>
                        <Row>
                            <Col md={6}>
                                <Form.Group>
                                    <Form.Label>Waypoint Description</Form.Label>
                                    <Form.Control
                                        as="textarea"
                                        rows={3}
                                        name="wpt_desc"
                                        value={formData.wpt_desc}
                                        onChange={handleInputChange}
                                    />
                                </Form.Group>
                            </Col>
                            <Col md={6}>
                                <Form.Group>
                                    <Form.Label>Vivekji's Description</Form.Label>
                                    <Form.Control
                                        as="textarea"
                                        rows={3}
                                        name="vivekji_desc"
                                        value={formData.vivekji_desc}
                                        onChange={handleInputChange}
                                    />
                                </Form.Group>
                            </Col>
                        </Row>

                        <Row>
                        <Col md={3}>
                <Form.Group>
                  <Form.Label>Average Time Spent (mins)</Form.Label>
                  <Form.Control
                    type="number"
                    name="avg_time_spent_min"
                    value={formData.avg_time_spent_min}
                    onChange={handleInputChange}
                  />
                </Form.Group>
              </Col>
              <Col md={3}>
                <Form.Group>
                  <Form.Label>Popular For</Form.Label>
                  <Form.Control
                    as="textarea"
                    rows={2}
                    name="popular_for"
                    value={formData.popular_for}
                    onChange={handleInputChange}
                  />
                </Form.Group>
              </Col>
              <Col md={3}>
                <Form.Group>
                  <Form.Label>Short Description</Form.Label>
                  <Form.Control
                    as="textarea"
                    rows={2}
                    name="short_desc"
                    value={formData.short_desc}
                    onChange={handleInputChange}
                  />
                </Form.Group>
              </Col>
              <Col md={3}>
                <Form.Group>
                  <Form.Label>Waypoint Category</Form.Label>
                  <Form.Control
                    type="text"
                    name="wpt_category_name"
                    value={formData.wpt_category_name}
                    onChange={handleInputChange}
                  />
                </Form.Group>
              </Col>
                        </Row>

                        <Row>
                            <Col md={3}>
                                <Form.Group>
                                    <Form.Label>Registered Accommodation Near By</Form.Label>
                                    <Form.Control
                                        as="select"
                                        name="d_reg_acmd"
                                        value={formData.d_reg_acmd}
                                        onChange={handleInputChange}
                                    >
                                        <option value="">Select</option>
                                        <option value="Yes">Yes</option>
                                        <option value="No">No</option>
                                    </Form.Control>
                                </Form.Group>
                            </Col>

                            <Col md={3}>
                                <Form.Group>
                                    <Form.Label>Registered Eateries Near By</Form.Label>
                                    <Form.Control
                                        as="select"
                                        name="d_reg_eateries"
                                        value={formData.d_reg_eateries}
                                        onChange={handleInputChange}
                                    >
                                        <option value="">Select</option>
                                        <option value="Yes">Yes</option>
                                        <option value="No">No</option>
                                    </Form.Control>
                                </Form.Group>
                            </Col>
                            <Col md={3}>
                                <Form.Group>
                                    <Form.Label>Registered Medical Facilities Near By</Form.Label>
                                    <Form.Control
                                        as="select"
                                        name="d_reg_medical"
                                        value={formData.d_reg_medical}
                                        onChange={handleInputChange}
                                    >
                                        <option value="">Select</option>
                                        <option value="Yes">Yes</option>
                                        <option value="No">No</option>
                                    </Form.Control>
                                </Form.Group>
                            </Col>
                            <Col md={3}>
                                <Form.Group>
                                    <Form.Label>Registered Clinics Near By</Form.Label>
                                    <Form.Control
                                        as="select"
                                        name="d_reg_clinic"
                                        value={formData.d_reg_clinic}
                                        onChange={handleInputChange}
                                    >
                                        <option value="">Select</option>
                                        <option value="Yes">Yes</option>
                                        <option value="No">No</option>
                                    </Form.Control>
                                </Form.Group>
                            </Col>
                            <Col md={3}>
                                <Form.Group>
                                    <Form.Label>Registered Hospitals Near By</Form.Label>
                                    <Form.Control
                                        as="select"
                                        name="d_reg_hosp"
                                        value={formData.d_reg_hosp}
                                        onChange={handleInputChange}
                                    >
                                        <option value="">Select</option>
                                        <option value="Yes">Yes</option>
                                        <option value="No">No</option>
                                    </Form.Control>
                                </Form.Group>
                            </Col>


                            <Col md={3}>
                                <Form.Group>
                                    <Form.Label>Distance to Bus Stand (in meters)</Form.Label>
                                    <Form.Control
                                        type="number"
                                        name="dist_bus_stnd"
                                        value={formData.dist_bus_stnd}
                                        onChange={handleInputChange}
                                    />
                                </Form.Group>
                            </Col>

                            <Col md={3}>
                                <Form.Group>
                                    <Form.Label>Distance to Railway Station (in meters)</Form.Label>
                                    <Form.Control
                                        type="number"
                                        name="dist_rail_stn"
                                        value={formData.dist_rail_stn}
                                        onChange={handleInputChange}
                                    />
                                </Form.Group>
                            </Col>

                            <Col md={3}>
                                <Form.Group>
                                    <Form.Label>Registered Hospital Near By</Form.Label>
                                    <Form.Control
                                        as="select"
                                        name="d_reg_hosp" // changed from status to correct name
                                        value={formData.d_reg_hosp}
                                        onChange={handleInputChange}
                                    >
                                        <option value="Yes">Yes</option>
                                        <option value="No">No</option>
                                    </Form.Control>
                                </Form.Group>
                            </Col>                        
                            {/* <Col md={3}>
                                <Form.Group>
                                    <Form.Label>Thumbnail</Form.Label>
                                    <Form.Control
                                        type="text"
                                        name="thumbnail"
                                        value={formData.thumbnail}
                                        onChange={handleInputChange}
                                    />
                                </Form.Group>
                            </Col> */}
                            <Col md={3}>
                                <Form.Group>
                                    <Form.Label>Image</Form.Label>
                                    <Form.Control
                                        type="file"
                                        name="image"
                                        onChange={handleFileChange}
                                    />
                                </Form.Group>
                            </Col>
                            <Col md={3}>
                                <Form.Group>
                                    <Form.Label>Status</Form.Label>
                                    <Form.Control
                                        as="select"
                                        name="status"
                                        value={formData.status}
                                        onChange={handleInputChange}
                                    >
                                        <option value="Active">Active</option>
                                        <option value="Inactive">Inactive</option>
                                    </Form.Control>
                                </Form.Group>
                            </Col>
                             <Col md={3}>
                                <Form.Group>
                                    <Form.Label>Tag</Form.Label>
                                    <Form.Control
                                        as="select"
                                        name="tag"
                                        value={formData.tag}
                                        onChange={handleInputChange}
                                        isInvalid={!!tagError}
                                    >
                                        <option value="">Select Tag</option>
                                        {uniqueOptions.map((tag, index) => (
                                            <option 
                                                key={index} 
                                                value={tag}
                                            >
                                                {tag}
                                            </option>
                                        ))}
                                    </Form.Control>
                                    {tagError && (
                                        <Form.Control.Feedback type="invalid">
                                            {tagError}
                                        </Form.Control.Feedback>
                                    )}
                                </Form.Group>
                            </Col>
                            {/* <Col md={3}>
                                <Form.Group>
                                    <Form.Label>Tag</Form.Label>
                                    <Form.Control
                                        as="select"
                                        name="tag" // updated to match formData key
                                        value={formData.tag}
                                        onChange={handleInputChange}
                                    >
                                        <option value="">Select Tag</option>
                                        {uniqueOptions.map((tag, index) => (
                                            <option key={index} value={tag}>
                                                {tag}
                                            </option>
                                        ))}
                                    </Form.Control>
                                </Form.Group>

                            </Col> */}
                        </Row>
                        <Row>
                        </Row>
                    </Form>
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={handleClose}>Close</Button>
                    <Button variant="primary" onClick={handleSubmit}>Update</Button>
                </Modal.Footer>
            </Modal >
        </>
    );
};

export default EditTagDetails;
